import { H3 } from '@berlitz/globals'
import Table from '@components/Table'
import * as React from 'react'
import { FormattedMessage } from 'react-intl'
import { Row } from 'react-styled-flexboxgrid'
import { GroupProfileProp } from './interface'
import { Box, Label, StyledButton, StyledButtonCol, NoPaddingCol } from './style'

class GroupProfile extends React.Component<GroupProfileProp> {
  state = { modalProfileOpen: false }

  defaultColumns = () => {
    return [
      {
        title: '',
        dataIndex: 'StudentName',
        key: 'StudentName',
        align: 'left',
        width: '10%',
        render: (text: string) => <Label named>{text}</Label>,
      },
      {
        title: '',
        dataIndex: 'Purpose',
        key: 'Purpose',
        align: 'left',
        width: '10%',
        render: (text: string) => <Label>{text}</Label>,
      },
    ]
  }

  toggleViewProfile = () => {
    const { modalProfileOpen } = this.state
    this.setState({ modalProfileOpen: !modalProfileOpen })
  }

  render() {
    const columns = this.defaultColumns()
    const { profiles, showLearningProfile } = this.props

    return (
      <>
        <Row>
          <NoPaddingCol xs={12} md={12}>
            <H3>
              <FormattedMessage id="Purpose of study" />
            </H3>
          </NoPaddingCol>
          <NoPaddingCol xs={12} md={12}>
            <Box>
              <Table columns={columns} dataSource={profiles} />
            </Box>
          </NoPaddingCol>
        </Row>
        <Row>
          <StyledButtonCol sm={12} md={12}>
            <div>
              <StyledButton outline onClick={showLearningProfile}>
                <FormattedMessage id="Group Learning profile" />
              </StyledButton>
            </div>
          </StyledButtonCol>
        </Row>
      </>
    )
  }
}

export default GroupProfile
